import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "col-sm-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onChange"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-sm-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_module_selector = _resolveComponent("module-selector")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Moduli visibili per ruolo",
        text: "Moduli visibili per ruolo"
      })
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRole && _ctx.addRole(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Aggiungi riga",
          text: "Aggiungi riga"
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row border-bottom mb-3",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Ruolo",
              text: "Ruolo"
            })
          ]),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(item.role) + " ", 1),
            (item.role)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-sm btn-danger",
                  onClick: ($event: any) => (item.role = '')
                }, "x", 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          (!item.role)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempRole) = $event)),
                onChange: ($event: any) => (_ctx.selectRole(item))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRoles, (role, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: role
                  }, _toDisplayString(role), 9, _hoisted_5))
                }), 128))
              ], 40, _hoisted_4)), [
                [_vModelSelect, _ctx.tempRole]
              ])
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_module_selector, {
          class: "col-sm-8",
          modelValue: item.modules,
          "onUpdate:modelValue": ($event: any) => ((item.modules) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: ($event: any) => (_ctx.removeRole(i))
          }, _hoisted_9, 8, _hoisted_7)
        ])
      ]))
    }), 128))
  ]))
}